import styles from './NewProgressBar.module.css';
import PropTypes from 'prop-types';

interface ProgressBarProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  variant?: 'determinate' | 'indeterminate';
  className?: string; // Nuevo prop para clases adicionales
}

export default function NewProgressBar({
  size = 'medium',
  text = 'Cargando...', // Texto por defecto
  variant = 'indeterminate',
  className = '',
}: ProgressBarProps) {
  const sizeClass = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
  }[size];

  const loaderClass =
    variant === 'determinate'
      ? `${styles.loaderDeterminate} ${sizeClass}`
      : `${styles.loaderIndeterminate} ${sizeClass}`;

  return (
    // Se concatena el prop className en el contenedor overlay
    <div className={`${styles.overlay} ${className}`}>
      <div className={styles.containerLoader}>
        <span className={loaderClass}></span>
        <div className={styles.loaderText}>{text}</div>
      </div>
    </div>
  );
}

NewProgressBar.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string,
  variant: PropTypes.oneOf(['determinate', 'indeterminate']),
  className: PropTypes.string,
};
